import { Format as CmsFormat } from '@helo/cms'

import {
  formatCollectionOptions,
  formatDateOptions,
  formatEmptyOptions,
  formatNumberOptions,
  formatOptions,
  formatTextOptions,
} from './Format.options'
import { FormatParts } from './Format.parts'

export const Format = {
  options: formatOptions,
  emptyOptions: formatEmptyOptions,
  textOptions: formatTextOptions,
  numberOptions: formatNumberOptions,
  dateOptions: formatDateOptions,
  collectionOptions: formatCollectionOptions,
  resolve: FormatParts.resolve,
  empty: CmsFormat.empty,
  text: CmsFormat.text,
  boolean: CmsFormat.boolean,
  id: CmsFormat.id,
  integer: CmsFormat.integer,
  integerParts: CmsFormat.integerParts,
  float: CmsFormat.float,
  floatParts: CmsFormat.floatParts,
  number: CmsFormat.number,
  numberParts: CmsFormat.numberParts,
  date: FormatParts.date,
  dateParts: CmsFormat.dateParts,
  relativeDate: CmsFormat.relativeDate,
  relativeDateParts: CmsFormat.relativeDateParts,
  join: CmsFormat.join,
  format: CmsFormat.format,
}
